module.exports = __webpack_public_path__ + "static/img/solar-energy-03.ee479b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/solar-energy/solar-energy-03.jpg
// module id = 9MEe
// module chunks = 96